module.exports = __webpack_public_path__ + "img/2.f0c8f9d0.png";